<template>
  <div v-if="isPickGradeActiveLocal">
    <div class="vx-row ml-1">
      <div class="vx-col">
        <vx-card card-background="transparent" class="remove-shadow card__no-padding" style="width: 277px">
          <vx-input-group>
            <vs-button
              :disabled="true"
              size="large"
              style="color:white;"
              class="button__fully-opaque button-text__left-align remove-shadow header_button-lookalike"
              type="filled"
              color="">
              You have selected:
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="ml-0">
      <div class="vx-row">
        <div class="vx-col flex-1">
          <vx-card card-background="transparent" class="mb-4 glow-effect_dark card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button-text__left-align glow-effect_primary__hover back-button"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="#262d4a"
                @click="backToPickLanguage">
                <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
                {{ selectedLanguage }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>
    </div>
    <div class="vx-row mt-3">
      <div class="vx-col">
        <vx-card card-background="transparent" class="remove-shadow card__no-padding" style="width: 277px">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text remove-shadow" style="background-color: transparent">
                <span><feather-icon class="pt-2" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="button__fully-opaque button-text__left-align remove-shadow header_button-lookalike text__school-font-color"
              type="filled"
              color="">
              Select a Grade
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="ml-4">
      <div v-for="(_group, index) in gradeGroups" :key="index">
        <vx-card card-background="transparent" class="remove-shadow card__no-padding" style="width: 277px">
          <vx-input-group>
            <vs-button
              :disabled="true"
              size="large"
              class="button__fully-opaque button-text__left-align remove-shadow header_button-lookalike text__school-font-color"
              type="filled"
              color="">
              {{ _group.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>

        <div class="vx-row">
          <div class="vx-col" v-for="(_grade, gradeIndex) in grades.filter(function(item){return item.group == _group.name})" :key="gradeIndex">
            <vx-card class="mb-4 glow-effect_dark fixed-width_grades card__no-padding bg-color">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg">
                    <span><feather-icon class="pt-2" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <vs-button
                  size="large"
                  class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                  style="border-radius:0 7px 7px 0;"
                  @click="selectGrade(_grade)">
                  {{ _grade.name }}
                </vs-button>
              </vx-input-group>
            </vx-card>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col mx-auto">
          <p v-if="showComingSoon" style="color:white;font-weight:500;font-size:16px;padding-top:5px">There are currently no grades for {{ selectedLanguage }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isPickGradeActive: {
      type: Boolean,
      required: true
    },
    selectedLanguage: {
      type: String,
      required: false
    },
    grades: {
      required: false
    },
    gradeGroups: {
      required: false
    },
    showComingSoon: {
      required: false
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    isPickGradeActiveLocal: {
      get() {
        return this.isPickGradeActive;
      }
    }
  },
  methods: {
    selectGrade(grade) {
      this.$emit("gradeSelected", grade);
    },
    backToPickLanguage() {
      this.$emit("backToPickLanguage");
    }
  },
  mounted() {
    
  }
};
</script>